import React, { Component } from 'react';

import MiniDrawer from '../../../components/SideMenu/SideMenuDrawer';
import RecordList from './RecordList';

export type Props = {
    history: {
        push: Function,
    },
};

class RecordListContainer extends Component<Props, {}> {
    state = {}
    render() {
        return (
            <MiniDrawer redirectTo={this.props.history.push}>
                <RecordList />
            </MiniDrawer>
        );
    }
}

export default RecordListContainer;
